import React from 'react';
import Dropdown from "./Dropdown.jsx";

export const FILTER_DROPDOWN_CONFIGURATION = Object.freeze({
    type: "modern",
    portal: true,
    portalBoundarySelector: ".layout-wide",
    contentClassName: "p-3",
});

function FilterDropdown({ align, title, button, children, inhibitClosing}) {
    return (
        <Dropdown
            {...FILTER_DROPDOWN_CONFIGURATION}
            align={align}
            title={title}
            button={button}
            inhibitClosing={inhibitClosing}
        >
            {children}
        </Dropdown>
    );
}

export default FilterDropdown;
